export default class ContactExpertSuccessController {
  /* @ngInject */
  constructor($stateParams, ExpertService, NavigationService) {
    const expertId = $stateParams.id;
    ExpertService
      .getExpert(expertId)
      .then((expert) => {
        this.expert = expert;
      });

    this.NavigationService = NavigationService;
  }

  returnToResultsPage() {
    this.NavigationService.navigateToSearchResults();
  }
}



// WEBPACK FOOTER //
// ./src/components/contact-expert-success/contact-expert-success.controller.js